import { useMutation } from '@apollo/client';
import { IconButton, SvgPin, SvgPinFill, Tooltip } from '@loomhq/lens';
import React, { MutableRefObject } from 'react';

import { PROFILE_VIDEO_PINNED, PROFILE_VIDEO_UNPINNED } from 'constants/events';
import * as analytics from 'utilities/analytics';

import UpdateUserPinnedVideo from '../../creators/UpdateUserPinnedVideo.graphql';

import styles from './styles.module.less';

export default function PinIcon({
  video,
  linkRef,
  sort,
  currentPinMaxValue,
  setToastMessage,
}: {
  video: any;
  linkRef: MutableRefObject<HTMLAnchorElement | null>;
  sort: number;
  currentPinMaxValue: number;
  setToastMessage: (showToast: boolean) => void;
}): JSX.Element | null {
  // Doesn't stay open when hovered off
  const handleButtonFocus = () => {
    linkRef.current?.classList.add(styles.showHoverState);
  };
  const handleButtonBlur = () => {
    linkRef.current?.classList.remove(styles.showHoverState);
  };

  const [togglePinnedVideo] = useMutation(UpdateUserPinnedVideo, {
    refetchQueries: ['GetLooms'],
  });

  const togglePin = sort => {
    if (sort == 0) {
      analytics.track(PROFILE_VIDEO_UNPINNED, {
        videoId: video.id,
      });
    } else {
      analytics.track(PROFILE_VIDEO_PINNED, {
        videoId: video.id,
      });
    }

    togglePinnedVideo({
      variables: { videoId: video.id, sort },
    });
  };

  return sort > 0 ? (
    <Tooltip content="Unpin from profile" placement="leftCenter" zIndex={0}>
      <IconButton
        altText={`Unpin ${video.name} from profile`}
        icon={<SvgPinFill />}
        size="small"
        onClick={() => togglePin(0)}
        onFocus={handleButtonFocus}
        onBlur={handleButtonBlur}
      />
    </Tooltip>
  ) : (
    <Tooltip content="Pin to profile" placement="leftCenter" zIndex={0}>
      <IconButton
        altText={`Pin ${video.name} to profile`}
        icon={<SvgPin />}
        size="small"
        onClick={() => {
          togglePin(currentPinMaxValue + 1);
          setToastMessage(true);
        }}
        onFocus={handleButtonFocus}
        onBlur={handleButtonBlur}
      />
    </Tooltip>
  );
}
